import { createFileRoute } from '@tanstack/react-router';

import CompanyDepartments from '@/modules/settings/pages/CompanyDepartments';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings/company-departments/',
)({
  head: () => ({
    meta: [{ title: 'Departamentos da Empresa' }],
  }),
  component: CompanyDepartments,
});
